// Navigation

export const navigationLinks = {
  title: {
    text: 'Careers',
    href: '/careers'
  },
  links: [
    {
      text: 'Mission',
      href: '/careers#about'
    },
    {
      text: 'Credos',
      href: '/careers#credos'
    },
    {
      text: 'Stories',
      href: '/careers#stories'
    },
    {
      text: 'Benefits',
      href: '/careers#benefits'
    },
    {
      text: 'Open Positions',
      href: '/careers#jobs'
    }
  ]
};

// Titles

export const aboutTitle = {
  overtitle: 'Our Mission',
  title: 'Scale is growing. Grow with us.'
};

export const valuesTitle = {
  overtitle: 'Our Credos',
  title: 'Credos, our internal core values, ensure we are aligned in executing on our mission',
  subtitle: 'Our credos provide a framework for us to make decisions and work effectively as a team.',
  link: {
    text: 'Explore our Positions',
    href: '/careers#jobs'
  }
};

export const pressTitle = {
  title: {
    text: 'In the News',
    color: 'text-black'
  },
  subtitle: {
    text: "Some of Scale's recent news coverage:",
    color: 'text-gray-800'
  }
};

export const teamTitle = {
  overtitle: 'Our Team',
  title: 'Meet our team',
  subtitle: 'No matter the role, everyone at Scale has a unique story to tell. Here are just some of them:'
};

export const technologyTitle = {
  icon: {
    src: '/static/img/website/careers/technology-icon.svg',
    alt: 'technology icon'
  },
  overtitle: {
    text: 'Our impact in the AI field',
    color: 'text-gradient-invert'
  },
  title: {
    text: 'Advancing machine learning systems via data labeling',
    color: 'text-white'
  }
};

export const benefitsTitle = {
  overtitle: 'Our Benefits',
  title: 'Supporting you to do your best work',
  subtitle: 'At Scale, we believe your talent and achievements deserve to be met with a supportive community and flexible environment.'
};

export const jobsTitle = {
  overtitle: 'Open Positions',
  title: `Help us bring human intelligence to software`
};

// ValuesSlider

export const valuesSlider = [
  {
    id: 1,
    icon: '/static/img/website/careers/values/earn-customer-love.png',
    title: 'Earn customer love',
    text:
      'We are passionate about our customers and devoted to their success. We know that customer trust and confidence is earned, not given, with every interaction, every delivery, and every time we solve a customer problem.'
  },
  {
    id: 2,
    icon: '/static/img/website/careers/values/intellectual-rigor.png',
    title: 'Intellectual rigor, open mind',
    text:
      'We think in clear verifiable hypotheses and continuously obtain data that validates or refutes them. We ask questions and challenge assumptions to get consistently to the truth.'
  },
  {
    id: 3,
    icon: '/static/img/website/careers/values/ambition-shapes-reality.png',
    title: 'Ambition shapes reality',
    text:
      'We are extremely ambitious in what we can accomplish. We set high standards, expecting to fail in the short-term but knowing that failure guides us to learn and ultimately succeed.'
  },
  {
    id: 4,
    icon: '/static/img/website/careers/values/team-flow.png',
    title: 'Team flow',
    text:
      'We are energized by each other’s success and actively invest in others with care, candor, and focus. Ideas flow openly between us because we treat each other with trust and respect.'
  },
  {
    id: 5,
    icon: '/static/img/website/careers/values/ownership-is-the-job.png',
    title: 'Ownership <i>is</i> the job',
    text:
      'We think like owners. We embody expansive ownership and are big believers in our ability to drive outcomes and enact change.'
  },
  {
    id: 6,
    icon: '/static/img/website/careers/values/run-through-walls.png',
    title: 'Run through walls',
    text:
      'We are undaunted by barriers and race towards overcoming them. We step outside of our comfort zone, test our ideas, and do the hard work to get to the right solution to a hard problem.'
  },
  {
    id: 7,
    icon: '/static/img/website/careers/values/up-the-tempo.png',
    title: 'Up the tempo',
    text:
      'We move with agility and intent, and swiftly make two-way door decisions that allow us to learn faster, adapt quickly, and ultimately do more.'
  },
  {
    id: 8,
    icon: '/static/img/website/careers/values/results-speak-loudest.png',
    title: 'Results speak loudest',
    text:
      'We define goals with intent and evaluate our outcomes with objectivity.  At the end of the day, we measure ourselves by our results.'
  }
];

// PressSlider

export const pressSlider = [
  {
    id: 1,
    href:
      'https://www.technologyreview.com/2020/05/22/1002129/data-save-autonomous-vehicles-coronavirus/',
    label: 'MIT Technology Review',
    caption: 'May 2020',
    img: {
      src: '/static/img/website/press/covers/mit-front.svg',
      alt: 'MIT',
      background: '#FFFFFF'
    }
  },
  {
    id: 2,
    href:
      'https://techcrunch.com/2020/05/22/scale-ai-releases-free-lidar-dataset-to-power-self-driving-car-development/',
    label: 'Techcrunch',
    caption: 'May 2020',
    img: {
      src: '/static/img/website/press/covers/techcrunch-front.svg',
      alt: 'Techcrunch',
      background: '#0ca200'
    }
  },
  {
    id: 3,
    href:
      'https://venturebeat.com/2020/02/03/new-data-set-helps-train-cars-to-drive-autonomously-in-winter-weather/',
    label: 'VentureBeat',
    caption: 'February 2020',
    img: {
      src: '/static/img/website/press/covers/vb-front.svg',
      alt: 'VB',
      background: '#FFFFFF'
    }
  },
  {
    id: 4,
    href: 'https://fortune.com/2020/02/04/artificial-intelligence-data-labeling-labelbox/',
    label: 'Fortune',
    caption: 'February 2020',
    img: {
      src: '/static/img/website/press/covers/fortune-front.svg',
      alt: 'Fortune',
      background: '#FFFFFF'
    }
  },
  {
    id: 5,
    href:
      'https://www.forbes.com/sites/jilliandonfro/2019/09/17/ai-50-americas-most-promising-artificial-intelligence-companies',
    label: 'Forbes',
    caption: 'September 2019',
    img: {
      src: '/static/img/website/press/press-8-front.svg',
      alt: 'Forbes',
      background: '#000000'
    }
  },
  {
    id: 6,
    href:
      'https://techcrunch.com/2019/08/05/scale-ai-and-its-22-year-old-ceo-lock-down-100-million-to-help-label-silicon-valleys-data/',
    label: 'Techcrunch',
    caption: 'August 2019',
    img: {
      src: '/static/img/website/press/covers/techcrunch-front.svg',
      alt: 'Techcrunch',
      background: '#0ca200'
    }
  },
  {
    id: 7,
    href:
      'https://www.bloomberg.com/news/articles/2019-08-05/scale-ai-is-silicon-valley-s-latest-unicorn',
    label: 'Bloomberg',
    caption: 'August 2019',
    img: {
      src: '/static/img/website/press/press-7-front.svg',
      alt: 'Bloomberg',
      background: '#FFFFFF'
    }
  },
  {
    id: 8,
    href:
      'https://techcrunch.com/2018/08/07/scale-whose-army-of-humans-annotate-raw-data-to-train-self-driving-and-other-ai-systems-nabs-18m/',
    label: 'Techcrunch',
    caption: 'August 2018',
    img: {
      src: '/static/img/website/press/covers/techcrunch-front.svg',
      alt: 'Techcrunch',
      background: '#0ca200'
    }
  },
  {
    id: 9,
    href: 'http://fortune.com/2018/08/08/term-sheet-wednesday-august-8/',
    label: 'Fortune',
    caption: 'August 2018',
    img: {
      src: '/static/img/website/press/covers/fortune-front.svg',
      alt: 'Fortune',
      background: '#FFFFFF'
    }
  },
  {
    id: 10,
    href: 'https://www.wired.com/story/scale-ai-label-share-self-driving-data/',
    label: 'Wired',
    caption: 'August 2018',
    img: {
      src: '/static/img/website/press/press-4-front.svg',
      alt: 'Wired',
      background: '#000000'
    }
  },
  {
    id: 11,
    href: 'https://www.ft.com/content/2a8941a4-1625-11e8-9e9c-25c814761640',
    label: 'Financial Times',
    caption: 'February 2018',
    img: {
      src: '/static/img/website/press/press-2-front.svg',
      alt: 'FT',
      background: '#fcd0ad'
    }
  },
  {
    id: 12,
    href: 'https://www.wsj.com/articles/scale-helps-engineers-outsource-microtasks-1495452603',
    label: 'The Wall Street Journal',
    caption: 'May 2017',
    img: {
      src: '/static/img/website/press/press-1-front.svg',
      alt: 'WSJ',
      background: '#4a4a4a'
    }
  }
];

// ICONS & IMAGES

export const LocationIcon = props => (
  <svg viewBox="0 0 28 28" {...props}>
    <path d="M14 17C14.6875 17 15.3542 16.9219 16 16.7656V27C16 27.2708 15.901 27.5052 15.7031 27.7031C15.5052 27.901 15.2708 28 15 28H13C12.7292 28 12.4948 27.901 12.2969 27.7031C12.099 27.5052 12 27.2708 12 27V16.7656C12.6458 16.9219 13.3125 17 14 17ZM14 0C16.2083 0 18.0938 0.78125 19.6562 2.34375C21.2188 3.90625 22 5.79167 22 8C22 10.2083 21.2188 12.0938 19.6562 13.6562C18.0938 15.2188 16.2083 16 14 16C11.7917 16 9.90625 15.2188 8.34375 13.6562C6.78125 12.0938 6 10.2083 6 8C6 5.79167 6.78125 3.90625 8.34375 2.34375C9.90625 0.78125 11.7917 0 14 0ZM14 3.5C14.1458 3.5 14.2656 3.45312 14.3594 3.35938C14.4531 3.26562 14.5 3.14583 14.5 3C14.5 2.85417 14.4531 2.73438 14.3594 2.64062C14.2656 2.54688 14.1458 2.5 14 2.5C12.4792 2.5 11.1823 3.03646 10.1094 4.10938C9.03646 5.18229 8.5 6.47917 8.5 8C8.5 8.14583 8.54688 8.26562 8.64062 8.35938C8.73438 8.45312 8.85417 8.5 9 8.5C9.14583 8.5 9.26562 8.45312 9.35938 8.35938C9.45312 8.26562 9.5 8.14583 9.5 8C9.5 6.76042 9.9401 5.70052 10.8203 4.82031C11.7005 3.9401 12.7604 3.5 14 3.5Z" />
  </svg>
);

export const TimeIcon = props => (
  <svg viewBox="0 0 32 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0049 28.0103C9.37748 28.0103 4.00488 22.6377 4.00488 16.0103C4.00488 9.38285 9.37748 4.01025 16.0049 4.01025C22.6323 4.01025 28.0049 9.38285 28.0049 16.0103C28.0049 22.6377 22.6323 28.0103 16.0049 28.0103ZM20.7529 18.2353L17.434 15.2448L16.7568 8.67885C16.7109 8.26464 16.3379 7.9661 15.9236 8.01205C15.5728 8.05097 15.2958 8.32797 15.2568 8.67885C15.2477 8.7668 14.5103 15.9194 14.5008 16.0066C14.4494 16.5141 14.7275 16.998 15.192 17.2089L19.9715 19.4389C20.3366 19.6044 20.7667 19.4427 20.9322 19.0776C21.0636 18.7879 20.991 18.4465 20.7531 18.2353H20.7529Z"
    />
  </svg>
);
